'use client';

import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { Text, Container, Image, Link } from '@weareconceptstudio/core';

//* HOO'C
import { withDataContext } from '@/context';

//* Styles
import GetTouchContactStyle from './style';

//* Animation
import { animationTitle } from '@/helpers/_animationTitle';

//* Lottie
import car from '../../../../public/lottie/contact/Car.json';
import help from '../../../../public/lottie/contact/Help.json';
import share from '../../../../public/lottie/contact/Share.json';

//* Component
import RatingAndReview from '@/modules/_Sections/RatingAndReview';
import LottieAnimation from '@/components/LottieAnimation';

const GetTouchContact = ({ title, info, globalData }) => {
	//! Refs
	const titleRef = useRef();
	const refSplit = useRef();
	const itemRef1 = useRef();
	const itemRef2 = useRef();
	const itemRef3 = useRef();

	//! Animation
	useEffect(() => {
		animationTitle({ element: titleRef.current, ref: refSplit });
		const animationWrapper = gsap.timeline();

		animationWrapper.to([itemRef1.current, itemRef2.current, itemRef3.current], {
			opacity: 1,
			duration: 0.8,
			ease: 'power2.out',
			delay: 0.4,
			stagger: 0.15,
		});
	}, []);

	return (
		<GetTouchContactStyle>
			<Container isSection>
				<Text
					ref={titleRef}
					tag={'h1'}
					className={'uppercase h1 title opacity-zero'}>
					{title}
				</Text>

				<div className='wrapper-info'>
					<Container
						full
						row>
						<div
							ref={itemRef1}
							className='opacity-zero col-4 col-t-6 col-m-12'>
							<div className='item-info'>
								<Image
									className={'icon-wrapper'}
									src={info[0].icon.src}
									alt={info[0].icon.alt}
								/>

								{/* <LottieAnimation
									className={'icon-wrapper'}
									loop={true}
									autoplay={true}
									isPlay={true}
									animData={car}
								/> */}

								<Text className={'h5 font-montserrat-arm-medium first-letter distance-subtitle'}>
									{info[0].title}
								</Text>
								{info[0].description ? (
									<div>
										<Text className={'p3 description-subtitle'}>{info[0].description}</Text>
									</div>
								) : null}

								<div className='wrapper-delivery-info'>
									{globalData.delivery?.text ? (
										<>
											<div className='wrapper-delivery-info-item'>
												<Text
													text={'everyday'}
													className={'p3 title-contact'}
												/>
												<Text className={'p4 font-montserrat-arm-medium'}>
													{globalData.delivery.text}
												</Text>
											</div>
										</>
									) : null}

									{globalData.address ? (
										<div className='wrapper-delivery-info-item'>
											<Text
												className={'p3 border-color title-contact'}
												text={'address'}
											/>

											<Link
												external
												className={'p4 font-montserrat-arm-medium underline hover-clickable'}
												url={globalData.address.link}>
												{globalData.address.line_1}
												&nbsp;
												{globalData.address.line_2}
											</Link>
										</div>
									) : null}

									{globalData.phones?.length > 0 ? (
										<div className='wrapper-delivery-info-item'>
											<Text
												className={'p3 border-color title-contact'}
												text={'phone'}
											/>
											<div className='wrapper-phones'>
												{globalData.phones.map((item, i) => {
													return (
														<Link
															external
															key={i}
															className={'width-fit-content hover-clickable'}
															url={`tel:${item}`}>
															<Text
																className={'p p4 font-montserrat-arm-medium underline'}>
																{item}
															</Text>
														</Link>
													);
												})}
											</div>
										</div>
									) : null}
								</div>
							</div>
						</div>

						<div
							ref={itemRef2}
							className='opacity-zero col-4 col-t-6 col-m-12'>
							<div className='item-info'>
								<Image
									className={'icon-wrapper'}
									src={info[1].icon.src}
									alt={info[1].icon.alt}
								/>

								{/* <LottieAnimation
									className={'icon-wrapper'}
									loop={true}
									autoplay={true}
									isPlay={true}
									animData={help}
								/> */}

								<Text className={'h5 font-montserrat-arm-medium first-letter distance-subtitle'}>
									{info[1].title}
								</Text>

								{info[1].description ? (
									<div>
										<Text className={'p3 description-subtitle'}>{info[1].description}</Text>
									</div>
								) : null}

								{globalData.email ? (
									<Link
										external
										className={
											'mail-text p p4 font-montserrat-arm-medium underline hover-clickable'
										}
										url={`mailto:${globalData.email}`}>
										{globalData.email}
									</Link>
								) : null}
							</div>
						</div>

						<div
							ref={itemRef3}
							className='opacity-zero col-4 col-t-6 col-m-12'>
							<div className='item-info'>
								<Image
									className={'icon-wrapper'}
									src={info[2].icon.src}
									alt={info[2].icon.alt}
								/>

								{/* <LottieAnimation
									className={'icon-wrapper'}
									loop={true}
									autoplay={true}
									isPlay={true}
									animData={share}
								/> */}

								<Text className={'h5 font-montserrat-arm-medium first-letter distance-subtitle'}>
									{info[2].title}
								</Text>

								{info[2].description ? (
									<div>
										<Text className={'p3 description-subtitle'}>{info[2].description}</Text>
									</div>
								) : null}

								<RatingAndReview className={'need-help color-reverse reverse'} />
							</div>
						</div>
					</Container>
				</div>
			</Container>
		</GetTouchContactStyle>
	);
};

export default withDataContext(GetTouchContact, ['globalData']);
